export const convertEpochMillisToDate = (epochMillis) => {
    if (!epochMillis) return '';

    const date = new Date(parseInt(epochMillis, 10));
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${day} - ${month} - ${year}`;
};

export const convertEpochMillisToDateTime = (epochMillis) => {
    if (!epochMillis) return '';

    const date = new Date(parseInt(epochMillis, 10));
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};
